// PRIMEIRO, sempre: tira o token de depuração da URL antes do router e de
// qualquer requisição (spec 020, FR-007)
import './auth/impersonation-boot';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from '@/lib/query-client';
import { router } from '@/router/router';
import { setUnauthorizedHandler } from '@/lib/api-client';
import { logoutSession } from '@/auth/use-auth';
import { AuthGate } from '@/auth/AuthGate';
import { isKeycloakMode } from '@/config/env';
import { isImpersonationPage } from '@/auth/impersonation';
import './index.css';

// Modo local: 401 limpa a sessão e volta pro login. No modo keycloak o
// AuthGate registra o handler (keycloak.login()) antes de renderizar o router.
// Na aba de depuração (spec 020) quem registra é o ImpersonationGate: 401 ali
// é sessão encerrada, nunca login — e nunca limpar a sessão do admin.
if (!isKeycloakMode && !isImpersonationPage()) {
  setUnauthorizedHandler(() => {
    logoutSession();
    if (window.location.pathname !== '/login') window.location.href = '/login';
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthGate>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </AuthGate>
  </StrictMode>
);
